import styled, { css, keyframes } from 'styled-components';
import { fadeIn } from '../../../shared';
import { deletableRowStyles } from '../../../containers/ProjectEntry/styled';
import { Grid } from '@mantine/core';

const spinAround = keyframes`
  from {
    transform: rotate(0deg);
  } to {
    transform: rotate(360deg);
  }
`;

const projectEntryActive = ({ active }) => {
  if (active) { 
    return css`
      max-height: 220px;
      padding: 5px 0px 5px 10px;
      border-top: 1px solid #e6e6e6;

      @media only screen and (max-width: 1023px) {
        max-height: 260px;
        padding: 5px 10px;
        margin-bottom: .5rem;
      }
    `
  } else {
    return css`
      max-height: 0px;
      transform: scaleY(0);
      padding: 0px 0px 0px 10px;

      @media only screen and (max-width: 1023px) {
        padding: 0px 10px;
      }
    ` 
  }
};

const ProjectEntryRow = styled(Grid)`
  overflow: hidden;
  transform: scaleY(1);
  transition: all .3s ease;
  margin-bottom: 8px;

  ${(props) => projectEntryActive(props)}
  ${(props) => deletableRowStyles(props)}
  
  > div {
    align-self: center;

    :not(:last-of-type) {
      div {
        white-space: nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    :last-of-type {

      .hours__input {
        display: block;
        width: 40px;
        height: 35px;
        text-align: center;
        margin: auto;
        padding: 0;
        background-clip: padding-box;
        transition: border-color, box-shadow 0.15s ease-in-out;
        border: 1px solid #dbdbdb;
        background-color: rgb(248, 248, 248);
        
        &:focus {
          border-color: #fe5d71;
          outline: 0;
          box-shadow: 0 0 0 0.2rem rgba(219, 1, 28, 0.25);
        }
      
        &.scheduled {
          background-color: #ffdce0;
        }
  
        &.fade-in {
          animation: ${fadeIn} .2s ease-in-out;
        }
          
        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }
`;


export {
  ProjectEntryRow
};